import image1 from '../../assets/programs/stem_mentorship/image1.webp'
import image_4 from '../../assets/programs/stem_mentorship/image_4.webp'
import image_5 from '../../assets/programs/stem_mentorship/image_5.webp'
import image_6 from '../../assets/programs/stem_mentorship/image_6.webp'
import image_7 from '../../assets/programs/stem_mentorship/image_7.webp'
import image8 from '../../assets/programs/stem_mentorship/image8.webp'
import image9 from '../../assets/programs/stem_mentorship/image9.webp'
import image10 from '../../assets/programs/stem_mentorship/image10.webp'
import image11 from '../../assets/programs/stem_mentorship/image11.webp'
import image_2 from '../../assets/programs/stem_mentorship/image_2.webp'

const stem_mentorship_data = {
    "title": "MANASVI: STEM MENTORSHIP PROGRAMME FOR HIGH SCHOOL GIRLS",
    "description": "A flagship initiative by the Academic Outreach and New Initiatives Office at IIT Delhi to inspire young girls to explore careers in Science, Technology, Engineering and Mathematics (STEM). The objective of the program is to improve the skewed gender ratio in STEM, and imbibe the girls with the right set of skills and mindset to encourage them to pursue careers in STEM. Manasvi aims to go beyond just academic engagement, by offering to these young girls a voice, a platform, and most importantly, a belief that they belong in STEM. For more details: https://youtu.be/0n3j4gK3QWM?si=DOPecXmwGjKtj6dd",
    "content": [
        {
            "primaryHeading": "",
            "subContent": [
                {
                    "secondaryHeading": "",
                    "description": "",
                    "images": [
                        {
                            "src": image1,
                            "desc": ""
                        },
                        {
                            "src": image_5,
                            "desc": ""
                        },
                        {
                            "src": image_6,
                            "desc": ""
                        },
                        {
                            "src": image_7,
                            "desc": ""
                        },
                        {
                            "src": image8,
                            "desc": ""
                        },
                        {
                            "src": image9,
                            "desc": ""
                        },
                        {
                            "src": image10,
                            "desc": ""
                        },
                        {
                            "src": image11,
                            "desc": ""
                        }
                    ]
                }
            ]
        }
    ]
}

export default stem_mentorship_data;